/**
 * The release number this console is running, as one string.
 *
 * WHY A MODULE AND NOT `__FV_VERSION__` AT EACH USE. Two screens show it — the
 * login form and the foot of the sidebar — and both are places somebody is
 * asked to read it out to support. A bare global at each site would work until
 * one of them was written `__FV_BUILD__` by mistake, which is a typo that
 * compiles, renders a plausible-looking string, and sends the support call after
 * the wrong number. Naming it once removes that.
 *
 * NOT THE BUILD ID. `__FV_BUILD__` is the commit sha `use-build-version.ts`
 * compares against `/version.json` to notice a deploy; it changes every time
 * anything ships and means nothing to a reader. This is the number in
 * `package.json`, which the whole workspace shares and which moves only on a
 * deliberate bump — the one the staff app also shows.
 */
export const APP_VERSION: string = __FV_VERSION__;

declare global {
  /**
   * Compiled in by `vite.config.ts` from `package.json`. Declared here rather
   * than in a shared ambient file for the same reason `__FV_BUILD__` is declared
   * in `use-build-version.ts`: the declaration belongs beside its only reader.
   */
  const __FV_VERSION__: string;
}
